export const URL_CONSTANTS = {
  ADD_PAY_RANGE: "/admin/pay-range-bill-rate/add-pay-range-bill-rate",
  ADMIN_DASHBOARD: "/admin/dashboard",
  ADMIN_EDIT_ROLE: "/admin/role-management/edit-role/",
  ADMIN_REVENUE_REPORT: "/admin/revenue-report",
  ASSIGN_APPLICANT: "/professional/assign",
  REASSIGN_APPLICANT: "/reassign",
  BILL_RATE: "/admin/pay-range-bill-rate",
  CALANDER: "/admin/calander",
  COMMUNICATION_VIEW: "contact",
  EDIT_JOB: "/admin/edit-job/",
  EDIT_ROLE: "edit-role",
  FIND_JOB_PROFESSIONAL: "/professional/find",
  FORGOT_PASSWORD: "/forgot-password",
  GET_BILL_DETAILS: "/professional/bill-details?date=",
  GET_JOB_PROFESSIONAL: "/professional",
  HOME: "/",
  JOB_VIEW: "/admin/jobs",
  JOBS: "/admin/jobs",
  LOGIN: "/login",
  NOTIFICATION: "/admin/notification",
  OFFICE_PROFILE: "/admin/office-users",
  POST_JOB: "/admin/add-job",
  PROFESSIONAL_PROFILE: "/admin/professional-users",
  PROFESSIONAL_TIMESHEET_VIEW: "/admin/timesheet/view-details",
  PROSPECT_ADD: "/admin/add-prospect",
  PROSPECT_EDIT: "/admin/prospect",
  PROSPECT_IMPORT_LOG: "/admin/prospects/import-log",
  PROSPECT_VIEW: "/admin/prospect-details",
  REFERRAL: "/admin/referral/",
  RE_ASSIGN_APPLICANT: "/reassign",
  ROLE_MANAGEMENT: "/admin/role-management",
  ROLE: "add-role",
  SHORTLIST_PROFESSIONAL: "/professional/shortlist",
  TIMESHEET_DISPUTE_LIST: "/admin/timesheet?tab=1",
  TIMESHEET_DISPUTE_VIEW: "/admin/timesheet-view",
  TIMESHEET_PROFESSIONAL_LIST: "/admin/timesheet/professional",
  TIMESHEET_WEEK_VIEW: "/admin/timesheet",
  UNASSIGN_APPLICANT: "/professional/unassign",
  VIEW_ROLE: "/admin/role-management/view-role/",
  INVOICE: "/admin/invoice",
  ON_ACCOUNT: "/admin/invoice/onAccount",
  CREDIT_MEMO: "/admin/invoice/creditMemo",
  NOTES: "/admin/notes",
  FIND_PROSPECTS: "/prospect/find",
  MANUAL_INVOICE_REPORT: "/admin/revenue-report/manual-invoice-report",
  JOB_ASSIGNMENTS: "/admin/jobs-assignments",
  PAY_SCALE_OFFICES: "/admin/pay-range-bill-rate/offices/",
  ADD_TRANSPARENCY_PAY_SCALE:
    "/admin/pay-range-bill-rate/transparency-model/add",
  TRANSPARENCY_MODEL: "/admin/pay-range-bill-rate/transparency-model",
};
